import { render, staticRenderFns } from "./CustomPL.vue?vue&type=template&id=59187c80&scoped=true&"
import script from "./CustomPL.vue?vue&type=script&lang=js&"
export * from "./CustomPL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59187c80",
  null
  
)

export default component.exports